const financeInfoTypes = {
    GET_LATEST_ARTICLES_START: 'GET_LATEST_ARTICLES_START',
    GET_LATEST_ARTICLES_SUCCESS: 'GET_LATEST_ARTICLES_SUCCESS',
    GET_LATEST_ARTICLES_FAILURE: 'GET_LATEST_ARTICLES_FAILURE',
    CLEAR_ARTICLES_ERROR: 'CLEAR_ARTICLES_ERROR',
    CLEAR_ARTICLES_STATE: 'CLEAR_ARTICLES_STATE',

};

export default financeInfoTypes;